var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mds-list-group-item',{attrs:{"text":_vm.termObject.name,"metadata-below":_vm.resultMetadata()},on:{"mds-list-item-clicked":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }